import React from 'react';

import type { Size } from '@atlaskit/icon';
import Tooltip from '@atlaskit/tooltip';

import { TestType, TestTypeAppearance } from '@qality/common-model';
import useOverflowObserver from '@qality/common-utils/src/hooks/useOverflowObserver';

import TestTypeColorUtil from './TestTypeColor.util';
import {
  TestTypeBackgroundStyled,
  TestTypeNameStyled,
} from './TestTypeComponent.styled';
import TestTypeIcon from './TestTypeIcon';

type Props = {
  testType: TestType;
  isIconOnly?: boolean;
  iconSize?: Size;
  appearance?: TestTypeAppearance;
  showTooltip?: boolean;
  maxWidth?: string;
};

export default function TestTypeComponent({
  testType,
  iconSize = 'small',
  isIconOnly = false,
  appearance = 'subtle',
  showTooltip = false,
  maxWidth,
}: Props): JSX.Element {
  const { ref, isOverflowing } = useOverflowObserver();

  const tooltipContent = `${testType.name} - ${testType.description}`;
  const isTooltipVisible = showTooltip || isOverflowing;
  return (
    <Tooltip content={isTooltipVisible && tooltipContent}>
      <TestTypeBackgroundStyled
        backgroundColor={TestTypeColorUtil.getBackgroundColor(
          appearance,
          testType.colorName
        )}
        maxWidth={maxWidth}
      >
        <TestTypeIcon
          iconName={testType.iconName}
          colorName={testType.colorName}
          appearance={appearance}
          size={iconSize}
          label='test-type-icon'
        />

        {!isIconOnly && (
          <TestTypeNameStyled
            textColor={TestTypeColorUtil.getTextColor(
              appearance,
              testType.colorName
            )}
            innerRef={ref}
          >
            {testType.name}
          </TestTypeNameStyled>
        )}
      </TestTypeBackgroundStyled>
    </Tooltip>
  );
}
